<template>
  <div>
    <el-form inline>
      <el-form-item label="送货单号">
        <el-input
          v-model="filters.TrackNumber"
          placeholder="请输入送货单号"
          clearable
          style="width: 200px"
        ></el-input>
      </el-form-item>

      <el-form-item label="客户">
        <el-input
          v-model="filters.CustomName"
          placeholder="请输入客户"
          clearable
        ></el-input>
      </el-form-item>

      <el-form-item label="预约时间">
        <el-date-picker
          v-model="filters.ExpectedTime"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item label="状态">
        <el-select v-model="filters.BookingStatus" multiple="" collapse-tags>
          <el-option label="提交" value="1"></el-option>
          <el-option label="已批准" value="2"></el-option>
          <el-option label="拒收" value="3"></el-option>
          <el-option label="取消预约" value="4"></el-option>
          <el-option label="已签收" value="5"></el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <!--工具条-->
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
    <!--表格-->
    <el-table-bar :fixed="true" :bottom="35">
      <el-table
        :data="tablelist"
        highlight-current-row
        border
        ref="multipleTable"
        v-loading="listLoading"
        @selection-change="selsChange"
        @row-click="handleRowClick"
        style="width: 100%"
      >
        <el-table-column type="selection" width="50"> </el-table-column>
        <el-table-column prop="bookingNo" width="140" label="预约单号">
        </el-table-column>
        <el-table-column prop="customName" width="80" label="客户">
        </el-table-column>
        <el-table-column prop="trackNumber" width="160" label="送货单号">
        </el-table-column>
        <el-table-column
          prop="bussbusinessTypeDesc"
          width=""
          label="业务类型"
        >
        </el-table-column>
        <el-table-column prop="warehouseName" width="120" label="仓库">
        </el-table-column>
        <el-table-column prop="skuCode" width="200" label="SKU">
        </el-table-column>

        <el-table-column prop="deliveryQty" width="" label="送货数量">
        </el-table-column>

        <el-table-column prop="deliveryWeight" width="80" label="重量">
        </el-table-column>

        <el-table-column prop="deliveryVolumeCbm" width="80" label="体积cbm" :formatter="formatPrice">
        </el-table-column>

        <el-table-column prop="expectedTimeDesc" width="180" label="预约时间">
        </el-table-column>
        <el-table-column prop="soNumber" width="130" label="SO单号">
        </el-table-column>
        <el-table-column prop="deliveryDateText" width="120" label="预计装柜时间">
        </el-table-column>
        <el-table-column prop="bookingStatusDesc" width="" label="状态">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.bookingStatus == 1">提交</el-tag>
            <el-tag type="success" v-if="scope.row.bookingStatus == 2"
              >已批准</el-tag
            >
            <el-tag type="danger" v-if="scope.row.bookingStatus == 3"
              >拒收</el-tag
            >
            <el-tag type="info" v-if="scope.row.bookingStatus == 4"
              >取消预约</el-tag
            ><el-tag type="success" v-if="scope.row.bookingStatus == 5"
              >已签收</el-tag
            >
          </template>
        </el-table-column>
 <el-table-column prop="suggestTime" width="180" label="建议送货时间">
        </el-table-column>
        <el-table-column prop="deliveryTypeDesc" width="120" label="送货方式">
          <template slot-scope="scope">
            <el-tag
              type="warning"
              v-if="scope.row.deliveryType == 1"
              effect="dark"
              >车辆派送</el-tag
            >
            <el-tag type="info" v-if="scope.row.deliveryType == 2" effect="dark"
              >快递派送
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="driverName" width="80" label="司机">
        </el-table-column>

        <el-table-column prop="driverCarNumber" width="120" label="车牌">
        </el-table-column>

        <el-table-column prop="driverPhone" width="120" label="司机电话">
        </el-table-column>

        <el-table-column prop="bookingUser" width="80" label="预约姓名">
        </el-table-column>

        <el-table-column prop="bookingPhone" width="120" label="预约电话">
        </el-table-column>

        <el-table-column prop="logisticsCompany" width="" label="快递公司">
        </el-table-column>

        <el-table-column prop="logisticsNumber" width="160" label="物流单号">
        </el-table-column>
      </el-table>
    </el-table-bar>

    <TablePaging :page="pager" :query="query"> </TablePaging>

    <!--编辑界面-->
    <!-- <el-dialog
      title="拒收"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="editForm"
        label-width="80px"
        :rules="editFormRules"
        ref="editForm"
      >
        <el-row>
          <el-col :span="16">
            <el-form-item
              label="建议送货时间"
              prop="SuggestTime"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-show="false"
                v-model="editForm.BookingDeliveryIDs"
                auto-complete="off"
              ></el-input>
              <el-date-picker
                v-model="editForm.SuggestTime"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <div>
          <el-row
            style="text-align: right; margin-top: 20px; margin-right: 20px"
          >
            <el-col :span="24">
              <el-form-item>
                <el-button @click="editFormVisible = false">关闭</el-button>
                <el-button
                  type="primary"
                  :loading="editLoading"
                  @click="editSubmit()"
                  >提交</el-button
                >
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </el-dialog> -->

    <el-dialog
      title="拒收"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="editForm"
        label-width="80px"
        :rules="editFormRules"
        ref="editForm"
      >
        <el-row class="editModal">
          <el-col :span="16">
            <el-form-item
              label="建议送货日期"
              prop="SuggestTime"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-show="false"
                v-model="editForm.BookingDeliveryIDs"
                auto-complete="off"
              ></el-input>
              <el-date-picker
                v-model="editForm.SuggestTime"
                type="date"
                placeholder="选择日期"
                @change="getSelectColumns"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="24">
              <el-form-item label="时间段" prop="expectedTime">
                 <el-select
                  v-model="editForm.ExpectedTime"
                  placeholder="请选择时间段"
                  clearable
                  filterable>
                    <el-option
                      v-for="item in selectColumns"
                      :label="item.text"
                      :value="item.value"
                      :key="item.value"
                    >
                      <div style="display: flex; justify-content: space-between;">
                        <span>{{ item.label }}</span>
                        <span :style="{color:getProportionColor(item.proportion)}">{{ getProprtionText(item.proportion) }}</span>
                      </div>
                      <div class="progressBarMain">
                        <div class="progressBar" :style="{width: item.proportion + '%',background:getProportionColor(item.proportion)}"></div>
                      </div>
                    </el-option>
                </el-select>
              </el-form-item>
            </el-col>
        </el-row>

        <div>
          <el-row
            style="text-align: right; margin-top: 20px; margin-right: 20px"
          >
            <el-col :span="24">
              <el-form-item>
                <el-button @click="editFormVisible = false">关闭</el-button>
                <el-button
                  type="primary"
                  :loading="editLoading"
                  @click="editSubmit()"
                  >提交</el-button
                >
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import util from "../../../util/date";
import { getButtonList } from "../../promissionRouter";
import axios from "axios";
import Toolbar from "../../components/Toolbar";
import TablePaging from "../../components/TablePaging";
import {
  GetBookingDeliveryList,
  ApprovalBookingDelivery,
  RejectionBookingDelivery,
  GetBookingPro
} from "@/api/bookingdelivery.js";

export default {
  components: { Toolbar, TablePaging },
  data() {
    return {
      pager: {
        total: 0,
        pageSize: 50,
        page: 1,
      },
      columns: [],
      buttonList: [],
      sels: [],
      editFormVisible: false,
      flag: false,
      filters: {},
      listLoading: false,
      tablelist: [],
      editForm: {},
      selectColumns:[],
      editLoading: false,
      editFormRules: {
        SuggestTime: [
          { required: true, message: "请选择建议送货时间", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    formatPrice(row, column, cellValue) {
      const value = parseFloat(cellValue);
    return isNaN(value) ? '0' : value.toFixed(3);
  },
    getProprtionText(proportion){
      return proportion === 100 ? '约满' : proportion > 50 ? '紧张' : '宽松'
    },
    getProportionColor(proportion) {
      return proportion == 100 ? '#f5a596' : proportion > 50 ? '#f100f1' : '#b1e47c'
    },
    query(page = 1) {
      this.listLoading = true;
      var para = {};
      // this.filters.page=this.pager.page;
      // this.filters.pageSize=this.pager.pageSize;

      this.newfilters.page = this.pager.page;
      this.newfilters.pageSize = this.pager.pageSize;
      GetBookingDeliveryList(this.newfilters).then((res) => {
        this.pager.total = res.data.response.total;
        this.tablelist = res.data.response.pageData;
        this.listLoading = false;
      });
    },
    selsChange: function (sels) {
      this.sels = sels;
    },
    //点击行触发，选中或不选中复选框
    handleRowClick(row, column, event) {
      this.flag = !this.flag;
      this.$refs.multipleTable.toggleRowSelection(row, this.flag);
    },

    getSelectColumns(date) {
      console.info(this.editForm.SuggestTime);
      if(date){
        GetBookingPro({ estimatedDate: util.formatDate.format(new Date(date), "yyyy-MM-dd") }).then(res => {
          if (res.data.status === 200 && res.data.success) {
              let newColumns = res.data.response.map(item => {
                  return {
                      label: `${item.expectedTime.split('-')[0]} 至 ${item.expectedTime.split('-')[1]}`,
                      value: item.expectedTime,
                      proportion: item.deliveryVolume * 100
                  }
              })
              this.$set(this, 'selectColumns', newColumns)
          } else {
              this.$set(this, 'selectColumns', [])
          }
        })
      } else {
        this.$set(this, 'selectColumns', [])
      }
    },



    callFunction(item) {
      // this.filters = {
      //     keyword: item.search
      // };
      // this[item.func].apply(this, item);

      this.$set(this.pager, "page", 1);

      this.newfilters = JSON.parse(JSON.stringify(this.filters));

      this[item.func].apply(this, [item]);
    },

    approval() {
      let row = this.sels;
      if (!row || row.length <= 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });

        return;
      }

      var isNoauid = false;
      row.forEach((item) => {
        if (
          item.bookingStatus == 2 ||
          item.bookingStatus == 3 ||
          item.bookingStatus == 4
        ) {
          isNoauid = true;
        }
      });
      if (isNoauid == true) {
        this.$message({
          message: "提交单据才能批准！",
          type: "error",
        });
        return;
      }

      const loading = this.$loading({
        lock: true,
        text: "批准中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });

      ApprovalBookingDelivery(row).then((res) => {
        loading.close();
        if (util.isEmt.format(res)) {
          this.listLoading = false;
          return;
        }
        this.listLoading = false;
        //NProgress.done();
        if (res.data.success) {
          this.$message({
            message: "批准成功",
            type: "success",
          });
        } else {
          this.$message({
            message: "批准失败!" + res.data.msg,
            type: "error",
          });
        }

        this.query(1);
      });
    },
    rejection() {
      let row = this.sels;
      if (this.sels == null || this.sels.length == 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });

        return;
      }

      var isNoauid = false;

      row.forEach((item) => {
        if (
          item.bookingStatus == 2 ||
          item.bookingStatus == 3 ||
          item.bookingStatus == 4
        ) {
          isNoauid = true;
        }
      });
      if (isNoauid == true) {
        this.$message({
          message: "提交单据才能操作",
          type: "error",
        });
        return;
      }
      this.editForm = {
        BookingDeliveryIDs: row
          .map((obj) => {
            return "" + obj.bookingDeliveryID + "";
          })
          .join(","),
      };

      this.editFormVisible = true;

      this.$nextTick(() => {
        this.$refs["editForm"].clearValidate();
      });
    },
    editSubmit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.editForm);

            RejectionBookingDelivery(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }
              if (res.data.success) {
                this.editLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                this.query(1);
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
                this.editLoading = false;
              }
            });
          });
        }
      });
    },
  },
  mounted() {
    //this.query(1);

    let user = JSON.parse(window.localStorage.user);
    // console.info(user)
    this.typeVisible = user.isSa;

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style lang="less" scoped>
.el-select-dropdown__item{
  height: auto
}
.progressBarMain{
  height: 4px;
  background: #fff;
  border: 1px solid #f5a596;
  border-radius: 4px;
}

.progressBar{
    background: #b1e47c;
    height: 4px;
}
.editModal{
   display: flex;
   > div{
    flex: 1;
   }
}
</style>